import React, {useCallback, useEffect, useState} from 'react'
import api from '../../helpers/api'
import {Select, Option} from '../../Korbantech/components/Inputs/Select'
import {Cause} from '../../types/Causes'
import {Trail} from '../../types/Trail'


interface OptionHelper extends Option {
    checked?: boolean
}

interface CausesHelper extends Cause {
    checked?: boolean
}

interface TrailsHelper extends Trail {
    checked?: boolean
}

export const RelatoryFilter = ({region, cause, city, period, score, knowledge}: Props) => {

    const [state, setState] = useState<OptionHelper[]>([])
    const [cities, setCities] = useState<OptionHelper[]>([])
    const [causes, setCauses] = useState<CausesHelper[]>([])
    const [trails, setTrails] = useState<TrailsHelper[]>([])

    const loadState = useCallback(async () => {
        await api.get('/locations/regions', {params: {select: true}}).then(res => {
            setState(res.data)
        }).catch(console.log)
        await api.get('/locations/cities', {params: {select: true}}).then(res => {
            setCities(res.data)
        })
        await api.get('/causes').then(res => {
            setCauses(res.data)
        })
        await api.get('/trails').then(res => {
            setTrails(res.data)
        })
    }, [])


    const [notes, setNotes] = useState<{ label: string, value: number, checked?: boolean }[]>([
        {label: "1", value: 1},
        {label: "2", value: 2},
        {label: "3", value: 3},
        {label: "4", value: 4},
        {label: "5", value: 5},
        {label: "6", value: 6},
        {label: "7", value: 7},
        {label: "8", value: 8},
        {label: "9", value: 9},
        {label: "10", value: 10},
    ])

    const [time, setTime] = useState<{ label: string, value: number, checked?: boolean }[]>([
        {label: "Hoje", value: 1},
        {label: "Essa Semana", value: 2},
        {label: "Últimos 30 dias", value: 3},
        {label: "Últimos 15 dias", value: 4},
        {label: "Esse Ano", value: 5},
    ])

    useEffect(() => {
        //  loadState()
    }, [loadState])
    return (
        <div className='grid grid-cols-5 gap-x-5 my-5'>
            {region &&
                <div>
                    <div className='font-semibold'>Região</div>
                    <Select multiple
                            selectLabel='Região'
                            selected={state.filter(c => c.checked).map(c => c.value)}
                            options={state}
                            onChange={opt =>
                                setState(prev =>
                                    prev.map(p =>
                                        opt.includes(p.value) ? {...p, checked: true} : {...p, checked: false}
                                    )
                                )
                            }
                    />
                </div>
            }{city &&
            <div>
                <div className='font-semibold'>Cidade</div>
                <Select multiple
                        selectLabel='Cidade'
                        selected={cities.filter(c => c.checked).map(c => c.value)}
                        options={cities}
                        onChange={opt =>
                            setCities(prev =>
                                prev.map(p =>
                                    opt.includes(p.value) ? {...p, checked: true} : {...p, checked: false}
                                )
                            )
                        }

                />
            </div>
        }{cause &&
            <div>
                <div className='font-semibold'>Causa</div>
                <Select multiple
                        selectLabel='Causa'
                        selected={causes.filter(c => c.checked).map(c => c.id)}
                        options={causes.map(c => ({
                            label: c.name,
                            value: c.id
                        }))}
                        onChange={opt =>
                            setCauses(prev =>
                                prev.map(p =>
                                    opt.includes(p.id) ? {...p, checked: true} : {...p, checked: false}
                                )
                            )
                        }

                />
            </div>
        }{score &&
            <div>
                <div className='font-semibold'>Notas</div>
                <Select multiple
                        selectLabel='Todas'
                        selected={notes.filter(c => c.checked).map(c => c.value)}
                        options={notes}
                        onChange={opt =>
                            setNotes(prev =>
                                prev.map(p =>
                                    opt.includes(p.value) ? {...p, checked: true} : {...p, checked: false}
                                )
                            )
                        }

                />
            </div>
        }{period &&
            <div>
                <div className='font-semibold'>Período</div>
                <Select
                    multiple
                    selectLabel='Causa'
                    selected={time.filter(c => c.checked).map(c => c.value)}
                    options={time}
                    onChange={opt =>
                        setTime(prev =>
                            prev.map(p =>
                                opt.includes(p.value) ? {...p, checked: true} : {...p, checked: false}
                            )
                        )
                    }

                />
            </div>
        }{knowledge &&
            <div>
                <div className='font-semibold'>Área de Conhecimento</div>
                <Select multiple
                        selectLabel='Conhecimento'
                        selected={trails.filter(c => c.checked).map(c => c.id)}
                        options={trails.map(c => ({
                            label: c.name,
                            value: c.id
                        }))}
                        onChange={opt =>
                            setTrails(prev =>
                                prev.map(p =>
                                    opt.includes(p.id) ? {...p, checked: true} : {...p, checked: false}
                                )
                            )
                        }

                />
            </div>
        }
        </div>
    )
}

interface Props {
    region?: boolean,
    cause?: boolean,
    city?: boolean,
    score?: boolean,
    period?: boolean,
    knowledge?: boolean,
}
